<nav class="navbar fixed top-0 w-full z-40 shadow-lg bg-top"
  [ngClass]="isHomeRoute() ? 'bg-opacity text-black' : 'bg-opacity_scrolled bg-white'" (scroll)="onWindowScroll();">
  @if (!isAuthRoute()) {
  @if (ApiService.isLoggedin() && showEmailVerificationBanner) {
  @if (ApiService.isEmployer()) {
  <div class="flex items-center gap-x-6 bg-freelancer px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
    <p class="text-sm leading-6 text-black truncate">
      Please go to your <a class="cursor-pointer text-blue-500" routerLink="/client-dashboard">dashboard</a> and
      verify your email address before March 15th, 2025 to keep your account active.
    </p>
    <div class="flex flex-1 justify-end">
      <!-- Add close button or action here if needed -->
    </div>
  </div>
  } @else if (ApiService.isEmployee()) {
  <div class="flex items-center gap-x-6 bg-freelancer px-6 py-2.5 sm:px-3.5 sm:before:flex-1">
    <p class="text-sm leading-6 text-black truncate">
      Please go to your <a class="cursor-pointer text-blue-500" routerLink="/freelancer-dashboard">dashboard</a>
      and verify your email address before May 30th, 2025 to keep your account active.
    </p>
    <div class="flex flex-1 justify-end">
      <!-- Add close button or action here if needed -->
    </div>
  </div>
  }
  }
  }

  <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
    <div class="relative flex items-center justify-between h-16">
      <div class="absolute inset-y-0 left-0 flex items-center md:hidden">
        <button type="button" (click)="showMenuOptions()"
          class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
          aria-controls="mobile-menu" aria-expanded="false">
          <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      <!-- Move search to right side -->
      <div class="absolute inset-y-0 right-0 flex items-center md:hidden">
        <div class="relative mx-2">
          <button (click)="toggleSearch()" class="p-2 text-gray-400 hover:text-gray-500 focus:outline-none">
            <i class="fas fa-search text-xl"></i>
          </button>
          <div *ngIf="showSearch"
            class="absolute right-0 mt-2 w-screen px-4 py-2 bg-white shadow-lg transition-all duration-300 ease-in-out t-100-manual">
            <div class="flex items-center">
              <select [(ngModel)]="searchType"
                class="w-24 text-sm px-2 py-2 bg-gray-100 border-0 rounded-l-md focus:ring-2 focus:ring-orange-500 text-gray-700">
                <option value="job">Jobs</option>
                <option value="freelancer">Freelancers</option>
              </select>
              <input type="text" [(ngModel)]="searchValue" (enterKeyPressed)="search()"
                class="w-full px-4 py-2 text-gray-700 bg-gray-100 border-0 focus:ring-2 focus:ring-orange-500"
                placeholder="Search...">
              <button (click)="toggleSearch()"
                class="px-4 py-2 bg-gray-100 rounded-r-md text-gray-400 hover:text-gray-500">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="hidden md:flex container mx-auto flex items-center justify-between px-4">
        <a routerLink="/home" class="text-xl font-semibold text-gray-800">
          <!-- <ng-container *ngIf="isScrolled || !isHomeRoute()">CDIwork</ng-container>
          <img class="h-8 w-auto sm:h-10" *ngIf="(!isScrolled && isHomeRoute())" src="assets/images/logo.png" alt=""> -->
          <img class="h-4 w-auto sm:h-6" src="assets/images/logo.png" alt="CDIWORK">
        </a>
        <ul class="flex items-center h-20-manual">
          <li class="ml-6">
            <a routerLink="/home"
              [ngClass]="(!isScrolled) ? 'text-black' :  isSelected('/home') ? 'text-black font-semibold':'text-gray-700' ">Home</a>
          </li>
          <li class="relative ml-6">
            <button type="button"
              class="flex items-center justify-between w-full py-2 px-3 rounded font-medium text-heading md:w-auto hover:bg-neutral-tertiary md:hover:bg-transparent md:border-0 md:hover:text-fg-brand md:p-0"
              (click)="isServiceOpen = !isServiceOpen" [attr.aria-expanded]="isServiceOpen" aria-haspopup="true">
              Services
              <svg class="w-4 h-4 ms-1.5 transition-transform duration-200" [class.rotate-180]="isServiceOpen"
                aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="m19 9l-7 7-7-7" />
              </svg>
            </button>

            <div
              class="absolute left-0 mt-2 z-10 hidden bg-white border border-default-medium rounded-base shadow-lg w-44"
              [class.hidden]="!isServiceOpen">
              <ul class="p-2 text-sm text-body font-medium">
                <li>
                  <button type="button"
                    class="flex items-center justify-between w-full p-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded font-medium"
                    (click)="isListingOpen = !isListingOpen" [attr.aria-expanded]="isListingOpen">
                    Listing
                    <svg class="w-4 h-4 ms-3 transition-transform duration-200" [class.rotate-180]="isListingOpen"
                      aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  <!-- Submenu for Listing -->
                  <ul class="overflow-hidden transition-all duration-300 ease-in-out"
                    [ngClass]="{'max-h-0': !isListingOpen, 'max-h-32': isListingOpen}">
                    <li>
                      <a routerLink="/service-listing-one" (click)="isServiceOpen = false"
                        class="block pl-8 py-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded">
                        Freelancer
                      </a>
                    </li>
                    <li>
                      <a routerLink="/service-listing-four" (click)="isServiceOpen = false"
                        class="block pl-8 py-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded">
                        Client
                      </a>
                    </li>
                  </ul>
                </li>

                <li class="mt-1">
                  <button type="button"
                    class="flex items-center justify-between w-full p-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded font-medium"
                    (click)="isAreasOpen = !isAreasOpen" [attr.aria-expanded]="isAreasOpen">
                    Areas
                    <svg class="w-4 h-4 ms-3 transition-transform duration-200" [class.rotate-180]="isAreasOpen"
                      aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  <!-- Submenu for Areas -->
                  <ul class="overflow-hidden transition-all duration-300 ease-in-out"
                    [ngClass]="{'max-h-0': !isAreasOpen, 'max-h-48': isAreasOpen}">
                    <li>
                      <a routerLink="/service-area/ethiopia" (click)="isServiceOpen = false"
                        class="block pl-8 py-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded">
                        Ethiopia
                      </a>
                    </li>
                    <li>
                      <a routerLink="/service-area/addis-ababa" (click)="isServiceOpen = false"
                        class="block pl-8 py-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded">
                        Addis Ababa
                      </a>
                    </li>
                    <li>
                      <a routerLink="/service-area/virginia" (click)="isServiceOpen = false"
                        class="block pl-8 py-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded">
                        Virginia
                      </a>
                    </li>
                    <li>
                      <a routerLink="/service-area/washington-dc" (click)="isServiceOpen = false"
                        class="block pl-8 py-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded">
                        Washington
                      </a>
                    </li>
                    <li>
                      <a routerLink="/service-area/maryland" (click)="isServiceOpen = false"
                        class="block pl-8 py-2 hover:bg-neutral-tertiary-medium hover:text-heading rounded">
                        Maryland
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
          <li class="ml-6">
            <a routerLink="/blogs"
              [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' :  isSelected('/blogs') ? 'text-black font-semibold':'text-gray-700' ">Blogs</a>
          </li>
          <li class="ml-6" *ngIf="ApiService.isEmployee()">
            <a routerLink="/freelancer-dashboard"
              [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : isSelected('/freelancer-dashboard') ? 'text-black font-semibold':'text-gray-700' ">Dashboard</a>
          </li>
          <li class="ml-6" *ngIf="ApiService.isEmployer()">
            <a routerLink="/client-dashboard"
              [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : isSelected('/client-dashboard') ? 'text-black font-semibold':'text-gray-700' ">Dashboard</a>
          </li>
          <li class="ml-6">
            <a routerLink="/all-jobs"
              [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : isSelected('/all-jobs') ? 'text-black font-semibold':'text-gray-700' ">Jobs</a>
          </li>
          <li class="ml-6">
            <a routerLink="/freelancers"
              [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : isSelected('/freelancers') ? 'text-black font-semibold':'text-gray-700' ">Freelancers</a>
          </li>
          <li class="ml-6" *ngIf="ApiService.isEmployer()">
            <a routerLink="/all-jobs/my-jobs"
              [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : isSelected('/all-jobs/my-jobs') ? 'text-black font-semibold':'text-gray-700' ">My
              Jobs</a>
          </li>
          <li class="ml-6" *ngIf="ApiService.isEmployee()">
            <a routerLink="/applied-jobs"
              [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : isSelected('/applied-jobs') ? 'text-black font-semibold':'text-gray-700' ">
              Applications</a>
          </li>
          <li class="ml-6" *ngIf="ApiService.isEmployer() || ApiService.isEmployee()">
            <a routerLink="/contracts"
              [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : isSelected('/contracts') ? 'text-black font-semibold':'text-gray-700' ">Contracts</a>
          </li>
          <li class="ml-6" *ngIf="isBrowser && !(jwtService.userProfile$ | async)">
            <a routerLink="/auth/login" [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : 'text-gray-700'">Log
              In</a>
          </li>

          <li class="ml-6" *ngIf="isBrowser && !(jwtService.userProfile$ | async)">
            <a routerLink="/auth/sign-up"
              class="text-black bg-cdi-freelancer-01 rounded-full py-2 px-4 font-semibold">Sign Up</a>
          </li>

          <div [ngClass]="{ 'relative': true, 'my-32': true }" class="relative my-32">
            <!-- <button (click)="openNotification()" class="relative z-10 block rounded-md bg-white p-2 focus:outline-none">
              <svg class="h-5 w-5 text-gray-800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
              </svg>
            </button> -->
            <button *ngIf="isLoggedIn" type="button" (click)="openNotificationWindow()"
              class="relative flex-shrink-0 mynav rounded-full p-1 ml-2 mr-2 text-gray-400 ">
              <i class="far fa-bell fa-lg text-2xl"
                [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : 'text-gray-700'"></i>
              <span class="sr-only">Notifications</span>
              <div *ngIf="(UnreadNotifications$ | async) as UnreadNotifications">
                <div *ngIf="UnreadNotifications !== 0"
                  class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-black bg-red-500 border-2 border-white rounded-full -top-2 -right-2">
                  {{ UnreadNotifications }}
                </div>
              </div>
            </button>
            <div [ngClass]="{'hidden': !notificationDropdownOpen, 'block': notificationDropdownOpen}"
              class="absolute right-0 mynav mt-2 bg-white rounded-md shadow-lg overflow-hidden z-20 w-23-manual">
              <div class="py-2">
                <!-- <div class="flex-shrink-0">
                  <svg class="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div> -->
                <div class="flex items-start px-4 py-3 bg-gray-100 -mx-2">
                  <div class="ml-3 w-0 flex-1 pt-0.5">
                    <p class="text-sm font-medium text-gray-900">Notifications</p>
                    <a href="" (click)="$event.preventDefault(); markAllAsRead()"
                      class="color-cdi-client-03 hover:text-indigo-900 flex-col items-end">Mark all as read</a>
                  </div>
                  <button class="ml-4 flex flex-shrink-0 cursor-pointer"
                    (click)="$event.preventDefault(); openNotificationWindow()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6">
                      <path fill-rule="evenodd"
                        d="M14.35 5.65a.5.5 0 0 1 0 .7L10.71 10l3.64 3.65a.5.5 0 0 1-.7.7L10 10.71l-3.65 3.64a.5.5 0 0 1-.7-.7L9.29 10 5.65 6.35a.5.5 0 0 1 .7-.7L10 9.29l3.65-3.64a.5.5 0 0 1 .7 0z" />
                    </svg>
                  </button>
                </div>


                <div class="overflow-y-auto overflow-x-hidden h-450-manual">
                  <a class="flex items-start px-4 py-3 border-b hover:bg-gray-100 -mx-2 cursor-pointer"
                    *ngFor="let notification of notifications" (click)="expandNotification(notification);"
                    [ngClass]="{'':notification.is_read, 'bg-gradient-to-r from-blue-100 to-transparent border-l-2 border-blue-500': selectedNotification === notification._id, 'bg-neutral-300' : !notification.is_read }">
                    <div class="ml-3 w-0 flex-1 pt-0.5">
                      <p class="text-sm font-medium text-gray-900">{{notification.title | titlecase}}</p>
                      <p *ngIf="!notification.showFullMessage" class="mt-1 text-sm text-gray-500">
                        {{notification.message | titlecase | slice:0:30}}.....</p>
                      <p *ngIf="notification.showFullMessage" class="mt-1 text-sm text-gray-500">
                        {{notification.message}}</p>
                    </div>
                    <div class="ml-4 flex flex-shrink-0">
                      <p class="text-sm text-gray-500">{{notification.created_at | dateAsAgo}}</p>
                    </div>
                  </a>
                </div>

              </div>
              <a *ngIf="notifications.length > 5" href="" (click)="$event.preventDefault(); loadMore()"
                class="block bg-cdi-client-03 text-white text-center font-bold py-2">Load More
                <div *ngIf="isLoading" class="block bg-gray-800 text-white text-center font-bold py-2">
                  Loading...
                </div>
              </a>
            </div>
          </div>
          <button *ngIf="isLoggedIn" type="button" routerLink="/messages"
            class="relative flex-shrink-0 rounded-full p-1 mr-2 text-gray-400 ">
            <i class="far fa-envelope fa-lg text-2xl"
              [ngClass]="(!isScrolled && isHomeRoute()) ? 'text-black' : 'text-gray-700'"></i>
            <span class="sr-only">Messages</span>
            <div *ngIf="(UnreadMessages$ | async) as UnreadMessages">
              <div *ngIf="UnreadMessages !== 0"
                class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-black bg-red-500 border-2 border-white rounded-full -top-2 -right-2">
                {{ UnreadMessages }}
              </div>
            </div>
          </button>

          <div class="relative ml-20-manual" *ngIf="isLoggedIn">
            <div>
              <img *ngIf="(ProfilePicture$ | async) !== 'uploads/default_profile.png'" class="h-10 w-10 rounded-full"
                [src]="imageURL + (ProfilePicture$ | async)" alt="" (click)="showProfileOptions()">
              <span *ngIf="!(ProfilePicture$ | async) || (ProfilePicture$ | async) === 'uploads/default_profile.png'"
                class="inline-flex h-12 w-12 items-center justify-center rounded-full bg-profile-text cursor-pointer">
                <span class="text-3xl font-large leading-none text-black" (click)="showProfileOptions()">
                  {{ (FullName$ | async)?.charAt(0).toUpperCase() }}
                </span>
              </span>

            </div>
          </div>
          <div [ngClass]="{'hidden': !showDropDown, 'block': showDropDown}"
            class="absolute right-0 z-10 mt-32 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1">
            <a *ngIf="ApiService.isEmployee()" routerLink="/my-freelancer-profile" (click)="showProfileOptions()"
              class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-0"><i
                class="fas fa-user"></i> Profile</a>
            <a *ngIf="ApiService.isEmployer()" routerLink="/employer-profile"
              class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-0"><i
                class="fas fa-user"></i> Profile</a>

            <a href="" *ngIf="ApiService.isEmployee()" routerLink="wallet/employee"
              class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-2"><i
                class="fas fa-wallet"></i> Earnings</a>
            <a href="" *ngIf="ApiService.isEmployer()" routerLink="wallet/employer"
              class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-2"><i
                class="fas fa-wallet"></i> Payments</a>
            <a href="" *ngIf="ApiService.isEmployer()" routerLink="invoices"
              class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-2"><i
                class="fas fa-wallet"></i> Invoices</a>

            <a *ngIf="ApiService.isEmployer()" routerLink="/packages" class="block px-4 py-2 text-sm text-gray-700"
              role="menuitem" tabindex="-1" id="user-menu-item-2"><i class="fas fa-cube"></i> Package</a>
            <a (click)="logout()" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1"
              id="user-menu-item-2"><i class="fas fa-sign-out-alt"></i> Sign out</a>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <div [ngClass]="{'hidden': !showMenu, 'block': showMenu}"
    class="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
    <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
      <div class="pt-5 pb-6 px-5">
        <div class="flex items-center justify-between">
          <a routerLink="/home">
            <img class="h-8 w-auto" src="assets/images/logo.png" alt="CDIwork">
          </a>
          <div class="-mr-2">
            <button type="button" (click)="showMenuOptions()"
              class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
              <span class="sr-only">Close menu</span>
              <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="py-6 px-5 space-y-6">
        <div class="grid grid-cols-2 gap-y-4 gap-x-8">
          <!-- <a href="" class="text-base font-medium text-gray-900 hover:text-gray-700"
            *ngIf="(FullName$ | async) as FullName">{{FullName | titlecase}}</a> -->
          <a routerLink="/home" class="text-base font-medium text-gray-900 hover:text-gray-700"> Home </a>
          <a routerLink="/all-jobs" class="text-base font-medium text-gray-900 hover:text-gray-700"> Jobs </a>
          <a routerLink="/freelancers" class="text-base font-medium text-gray-900 hover:text-gray-700">
            Freelancers </a>
          <a routerLink="/blogs" lass="text-base font-medium text-gray-900 hover:text-gray-700">
            Blogs
          </a>
          <a routerLink="/guides" lass="text-base font-medium text-gray-900 hover:text-gray-700">
            Guides
          </a>
          <a routerLink="/packages" *ngIf="ApiService.isEmployer()"
            class="text-base font-medium text-gray-900 hover:text-gray-700"> Package </a>
          <a routerLink="/all-jobs/my-jobs" *ngIf="ApiService.isEmployer()"
            class="text-base font-medium text-gray-900 hover:text-gray-700"> My Jobs</a>
          <a routerLink="/messages" *ngIf="isLoggedIn" class="text-base font-medium text-gray-900 hover:text-gray-700">
            Messages
          </a>
          <a routerLink="/notifications" *ngIf="isLoggedIn"
            class="text-base font-medium text-gray-900 hover:text-gray-700">
            Notifications
          </a>

          <a routerLink="/wallet/employer" *ngIf="ApiService.isEmployer()"
            class="text-base font-medium text-gray-900 hover:text-gray-700"> Payments </a>
          <a routerLink="/invoices" *ngIf="ApiService.isEmployer()"
            class="text-base font-medium text-gray-900 hover:text-gray-700"> Invoices </a>
          <a routerLink="/wallet/employee" *ngIf="ApiService.isEmployee()"
            class="text-base font-medium text-gray-900 hover:text-gray-700"> Earnings </a>
          <a routerLink="/applied-jobs" *ngIf="ApiService.isEmployee()"
            class="text-base font-medium text-gray-900 hover:text-gray-700"> Applications </a>
          <a routerLink="/contracts" *ngIf="ApiService.isEmployee() || ApiService.isEmployer()"
            class="text-base font-medium text-gray-900 hover:text-gray-700"> Contracts
          </a>
          <a routerLink="/freelancer-dashboard" *ngIf="ApiService.isEmployee()"
            class="text-base font-medium text-gray-900 hover:text-gray-700"> Dashboard
          </a>
          <a routerLink="/client-dashboard" *ngIf="ApiService.isEmployer()"
            class="text-base font-medium text-gray-900 hover:text-gray-700"> Dashboard
          </a>
          <a *ngIf="!isLoggedIn" routerLink="/auth/sign-up"
            class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">
            Sign up </a>
          <p *ngIf="!isLoggedIn" class="mt-6 text-center text-base font-medium text-gray-500">
            Existing customer?
            <a routerLink="/auth/login" class="mt-2 color-cdi-client-03 hover:text-indigo-500"> Login </a>
          </p>
        </div>
        <div>

          <ng-container *ngIf="isLoggedIn">
            <a *ngIf="ApiService.isEmployee()" routerLink="/my-freelancer-profile"
              class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">
              Profile </a>
            <a *ngIf="ApiService.isEmployer()" routerLink="/employer-profile"
              class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">
              Profile </a>
            <a (click)="logout()" routerLink="/employer-profile"
              class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">
              Sign out</a>
          </ng-container>
          <!-- <ng-container >
            <a routerLink="/home"
              class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">Home</a>

            <a routerLink="/blogs"
              class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">Blogs</a>
            <a routerLink="/guides"
              class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">Guides</a>
            <a routerLink="/all-jobs"
              class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">Jobs</a>
            <a routerLink="/freelancers"
              class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">Freelancers</a>
            <a *ngIf="jwtService.userProfile === null" routerLink="/auth/sign-up"
              class="w-full flex items-center justify-center px-4 py-2 mt-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-cdi-client-03 ">
              Sign up </a>
            <p *ngIf="jwtService.userProfile === null" class="mt-6 text-center text-base font-medium text-gray-500">
              Existing customer?
              <a *ngIf="jwtService.userProfile === null" routerLink="/auth/login"
                class="mt-2 color-cdi-client-03 hover:text-indigo-500"> Login </a>
            </p>
          </ng-container> -->
        </div>
      </div>
    </div>
  </div>
</nav>
